import { useEffect, useState } from 'react'
import { useLocalStorage, useMediaQuery } from 'usehooks-ts'

import {
  POSTHOG_FEATURE_FLAGS,
  usePostHogFeatureFlag
} from '@percent/admin-dashboard/common/hooks/usePostHogFeatureFlag'
import { NAVIGATION_COLLAPSED_WIDTH, NAVIGATION_WIDTH } from '@percent/lemonade'

export const AUTO_COLLAPSE_MEDIA_QUERY = '(max-width: 1279px)'
export const COLLAPSED_STORAGE_KEY = 'ad-navbar-collapsed'

/*
  Below the breakpoint the panel always starts collapsed; expanding it there is
  temporary and not saved, so the wide-screen preference survives a resize.
*/
export function useSideNavCollapse() {
  const isEnabled = usePostHogFeatureFlag(POSTHOG_FEATURE_FLAGS.AD_COLLAPSIBLE_SIDE_NAV)
  const [isCollapsedPreference, setIsCollapsedPreference] = useLocalStorage(COLLAPSED_STORAGE_KEY, false)
  const isNarrow = useMediaQuery(AUTO_COLLAPSE_MEDIA_QUERY)
  const [isCollapsed, setIsCollapsed] = useState(isNarrow || isCollapsedPreference)

  useEffect(() => {
    setIsCollapsed(isNarrow || isCollapsedPreference)
  }, [isNarrow, isCollapsedPreference])

  if (!isEnabled) {
    return { isCollapsed: false, width: NAVIGATION_WIDTH, toggleCollapsed: undefined }
  }

  const toggleCollapsed = () => {
    if (!isNarrow) {
      setIsCollapsedPreference(!isCollapsed)
    }

    setIsCollapsed(!isCollapsed)
  }

  return {
    isCollapsed,
    width: isCollapsed ? NAVIGATION_COLLAPSED_WIDTH : NAVIGATION_WIDTH,
    toggleCollapsed
  }
}
